import React from 'react';
import PropTypes from 'prop-types';

export default class LookupForm extends React.Component {

    handleCardNumberChange = (event) => {
        this.props.onCardNumberChange(event.target.value);
    };

    handleSubmit = (event) => {
        event.preventDefault();
        this.props.onSubmit();
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit} className="widget--giftcard widget--search widget--search--shadow widget--search--blue margin--50--top">
                <label htmlFor="cardNumber" className="widget--search__label">
                    <img src="/img/icon-tick--lime.svg" alt="" className="tick" />
                    <span className="u-vis-hide">Gift card number</span>
                    <input
                        type="text"
                        name="cardNumber"
                        id="cardNumber"
                        className="widget--search__input text--center"
                        placeholder="Gift card number"
                        value={this.props.cardNumber}
                        autoComplete="off"
                        onChange={this.handleCardNumberChange} />
                </label>
                <button className="widget--search__btn" type="submit">
                    <img src="/img/icon-search--white.svg" alt="" className="icon" />
                    <span className="u-vis-hide">Submit</span>
                </button>
            </form>
        )
    }
}

LookupForm.propTypes = {
    cardNumber: PropTypes.string,
    onCardNumberChange: PropTypes.func,
    onSubmit: PropTypes.func
};
